<template>
  <div>
    <a-table
      class="col-width-max-content"
      :columns="columns"
      :data-source="data"
      :scroll="{ x: true }"
      :rowKey="(record, index) => `record_index_${index}`"
      :customRow="onRowClick"
    >
      <div slot="eventdttm" slot-scope="text">
        {{ text && getFormatDate(text) }}
      </div>
    </a-table>
  </div>
</template>
<script>
import { getFormatDate } from "@/views/components/fnc.js"
export default {
  props: {
    data: {
      type: Array,
      default: () => []
    },
    columns: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    getFormatDate (date) {
      return getFormatDate(date)
    },
    onRowClick (item) {
      return {
        on: {
          click: () => {
            this.$emit("click", item)
          },
          dblclick: () => {
            this.$emit("dblclick", item)
          }
        }
      }
    }
  },
  components: {}
}
</script>